export default {

  /*
   * Paints this view's `$el` based on the view's `props`.
   *
   */
  paint: function (animate) {
    this.canvas.queue(() => {
      this.$el.toggleClass('animated-paint', animate === true)

      var props = this.props()

      this.$el.css(props)
      this.$el.toggleClass('wob-in-top-threshold', this.model.get('top') < 65)

      this.rotate(this.model, this.model.get('rotate'))

      if (animate) {
        setTimeout(() => this.$el.toggleClass('animated-paint', false), this.canvas.animation_duration)
      }
    })
  }

}
